import loginBackground from './assets/bg-login.png';
import starsBackground from './assets/bg-stars.png';
import marketingBackground from './assets/bg-marketing.png';

export const AppBackgroundLogin = loginBackground;
export const AppBackgroundStars = starsBackground;
export const AppBackgroundMarketing = marketingBackground;
export const AppBackgroundTriangleBgDarkBlueSrc = '/images/triangle-bg-darkBlue.svg';
export const AppBackgroundTriangleBgTurquoiseSrc = '/images/triangle-bg-turquoise.svg';
export const AppBackgroundTriangleBgDarkBlueBigSrc = '/images/triangle-bg-darkBlue-big.svg';
